export const CHANGE_TAB = "@analytics/CHANGE_TAB";
export const CHANGE_TIMEOUT = "@analytics/CHANGE_TIMEOUT";
export const CLEAR_QUERY = "@analytics/CLEAR_QUERY";
export const EXECUTE_QUERY = "@analytics/EXECUTE_QUERY";
export const QUERY_CHANGED = "@analytics/QUERY_CHANGED";
export const QUERY_ERROR = "@analytics/QUERY_ERROR";
export const QUERY_RESULT_CHANGED = "@analytics/QUERY_RESULT_CHANGED";
